import React from 'react'


export const SortStateContext = React.createContext()
export const SearchQueryContext = React.createContext()
export const HebrewSortStateContext = React.createContext()
export const HebrewSearchQueryContext = React.createContext()
export const ArticleSortStateContext = React.createContext()
export const ArticleSearchQueryContext = React.createContext()